import React from "react";
import "../styles/Items.css";

// 🔹 Import your 10 images
import abc from "../assets/images/0itm101.webp";
import abc1 from "../assets/images/0itm102.webp";
import abc2 from "../assets/images/0itm103.webp";
import abc3 from "../assets/images/0itm104.webp";
import abc4 from "../assets/images/0itm105.webp";
import abc5 from "../assets/images/0itm106.webp";
import abc6 from "../assets/images/0itm107.webp";
import abc7 from "../assets/images/0itm108.webp";
import abc8 from "../assets/images/0itm109.webp";
import abc9 from "../assets/images/0itm110.webp";
import abc10 from "../assets/images/0itm111.webp";
import abc11 from "../assets/images/0itm112.webp";

const Items = () => {
  // 🔹 Array of cards
  const items = [
    { img: abc, title: "HVAC And MEP", link: "/Z1" },
    { img: abc1, title: "AC Tools & Accessories", link: "/Z2" },
    { img: abc2, title: "Electrical Items", link: "/Z3" },
    { img: abc3, title: "Hydraulic Lubricant", link: "/Z4" },
    { img: abc4, title: "Pneumatics", link: "/Z5" },
    { img: abc5, title: "Mechanical Parts", link: "/Z6" },
    { img: abc6, title: "Pipes, Valves & Fittings", link: "/Z7" },
    { img: abc7, title: "Air Compressor & Spare Parts", link: "/Z8" },
    { img: abc8, title: "Mechanical Spare Parts", link: "/Z9" },
    { img: abc9, title: "Safety & PPE'S", link: "/Z10" },
     { img: abc10, title: "Tools And Accessories", link: "/Z11" },
    { img: abc11, title: "Electronic Repairs", link: "/Z12" },
  ];

  return (
    <section className="items-section" id="items">
      <h2 className="items-heading">Our Products Category</h2>
      <div className="items-grid">
        {items.map((item, index) => (
          <a
            key={index}
            href={item.link}
            className="item-card"
          >
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Items;
